import { render, staticRenderFns } from "./accordion-checkout.vue?vue&type=template&id=630c2ff8&"
import script from "./accordion-checkout.vue?vue&type=script&lang=js&"
export * from "./accordion-checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports